(function () {
'use strict';
if (window.__libraryMemberLines) { return; }
window.__libraryMemberLines = true;
var el = document.querySelector('script[data-library-companion]');
var d = el ? el.dataset : {}, original = window.fetch;
var cfg = {
membership: (d.membership || '').split(',').map(Number),
cap: Number(d.cap) || 0, paying: d.paying === 'true',
vendor: d.vendor, suffix: d.suffix || ''
};
var root = d.root || '/', cache = {}, queue = Promise.resolve();
if (root.charAt(root.length - 1) !== '/') { root += '/'; }
function eligible(item, s) {
return item.requires_shipping &&
s.membership.indexOf(Number(item.variant_id || item.id)) === -1;
}
function handle(item, s) {
var h = item.handle || '', suffix = s.suffix;
if (item.vendor !== s.vendor) { return h + suffix; }
return suffix && h.slice(-suffix.length) === suffix ? h.slice(0, -suffix.length) : '';
}
function signature(p) {
return JSON.stringify(Object.keys(p || {}).sort().map(function (k) { return [k, p[k]]; }));
}
function plan(cart, products, s) {
var result = { add: [], set: {} }, items = cart.items || [];
var member = s.paying, left, merged = {};
items.forEach(function (item) {
if (s.membership.indexOf(Number(item.variant_id || item.id)) !== -1) { member = true; }
});
left = member ? (s.paying ? Infinity : s.cap) : 0;
function move(item, quantity) {
var product = products[handle(item, s)], variant;
if (!quantity || !product || !item.sku) { return; }
(product.variants || []).some(function (v) {
if (v.sku === item.sku) { variant = v; return true; }
return false;
});
if (!variant) { return; }
var key = String(variant.id) + ':' + signature(item.properties), a = merged[key];
if (!a) {
a = { id: variant.id, quantity: 0 };
if (Object.keys(item.properties || {}).length) { a.properties = item.properties; }
merged[key] = a;
result.add.push(a);
}
a.quantity += quantity;
result.set[item.key] = item.quantity - quantity;
return true;
}
items.forEach(function (item) {
if (!eligible(item, s) || item.vendor !== s.vendor) { return; }
var keep = Math.min(item.quantity, left);
left -= keep;
move(item, item.quantity - keep);
});
if (member) {
items.forEach(function (item) {
if (!eligible(item, s) || item.vendor === s.vendor) { return; }
var quantity = Math.min(item.quantity, left);
if (move(item, quantity)) { left -= quantity; }
});
}
return result;
}
function read(path) {
return original.call(window, root + path, { credentials: 'same-origin' }).then(function (r) {
if (!r.ok) { throw new Error(); }
return r.json();
});
}
function product(h) {
if (Object.prototype.hasOwnProperty.call(cache, h)) { return Promise.resolve(cache[h]); }
return original.call(window, root + 'products/' + encodeURIComponent(h) + '.js', {
credentials: 'same-origin'
}).then(function (r) {
if (r.status === 404) { cache[h] = null; return null; }
if (!r.ok) { throw new Error(); }
return r.json().then(function (p) { cache[h] = p; return p; });
});
}
function post(path, body) {
return original.call(window, root + path, {
method: 'POST', credentials: 'same-origin',
headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
}).then(function (r) { return !!r.ok; });
}
function perform() {
if (!el || !cfg.vendor || !original) { return Promise.resolve(false); }
return read('cart.js').then(function (cart) {
var needed = {}, products = {};
(cart.items || []).forEach(function (item) {
if (eligible(item, cfg)) {
var h = handle(item, cfg);
if (h) { needed[h] = true; }
}
});
return Promise.all(Object.keys(needed).map(function (h) {
return product(h).then(function (p) { products[h] = p; });
})).then(function () {
var p = plan(cart, products, cfg);
if (!p.add.length) { return false; }
return post('cart/add.js', { items: p.add }).then(function (added) {
if (!added) { return false; }
return post('cart/update.js', { updates: p.set }).then(function () { return true; });
});
});
});
}
function sync() {
queue = queue.then(perform).catch(function () { return false; });
return queue;
}
window.LibraryMemberLines = { plan: plan, sync: sync };
if (!el || !cfg.vendor || !original) { return; }
window.fetch = function (input, init) {
var watched = false;
try {
var u = new URL(typeof input === 'string' ? input : input.url, window.location.origin);
var method = (init && init.method) || (input && input.method) || 'GET';
watched = String(method).toUpperCase() === 'POST' && u.origin === window.location.origin &&
/^\/(?:[a-z]{2}(?:-[a-z]{2,4})?\/)?cart\/(?:add|change|update|clear)\.js$/i.test(u.pathname);
} catch (e) {}
return Promise.resolve().then(function () {
return original.call(window, input, init);
}).then(function (r) {
if (!watched || !r.ok) { return r; }
return sync().then(function (changed) {
if (!changed) { return r; }
return r.clone().json().then(function (data) {
if (!data.sections || typeof data.sections !== 'object') { return r; }
return read('?sections=library-basket&sections_url=' + encodeURIComponent(window.location.pathname)).then(function (fresh) {
if (typeof fresh['library-basket'] !== 'string') { return r; }
data.sections['library-basket'] = fresh['library-basket'];
return new Response(JSON.stringify(data), {
status: r.status, headers: { 'Content-Type': 'application/json' }
});
});
});
}).catch(function () { return r; });
});
};
if (/(?:^|;\s*)cart=/.test(document.cookie || '')) {
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', function () { sync(); }, { once: true });
} else { sync(); }
}
}());
